import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                  <i className="ri-film-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-bold text-foreground-50 font-heading">6080影院</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {siteInfo.tagline}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">电影分类</h4>
              <div className="space-y-2">
                {categories.slice(1, 7).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">快速链接</h4>
              <div className="space-y-2">
                <Link to="/" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
                <Link to="/category/latest" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  最新电影
                </Link>
                <Link to="/category/classic" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  经典电影
                </Link>
                <Link to="/about" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">联系我们</h4>
              <div className="space-y-2 text-sm text-foreground-400">
                <p>邮箱：{siteInfo.contact.email}</p>
                <p>微信：{siteInfo.contact.wechat}</p>
                <p>电话：{siteInfo.contact.phone}</p>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 6080影院 版权所有 | 电影大全 最新电影 经典电影 动作电影 喜剧电影
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors">服务条款</a>
              <a href="#" className="hover:text-primary-400 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}